export default __webpack_public_path__ + "assets/img/error-img-dark.svg";